<template lang="pug">
filter-detail-container(
  :title="$t('filter_order_count')"
  @back="back"
  @save="save"
)
  template(v-slot:body)
    .pa-6
      .mb-4 {{ $t('filter_order_count_with_value') }}:
      yc-select.mt-4(v-model="condition" :items="options")
      yc-text-field.mt-4(:label="$t('enter_value')" v-model="count" type="number")
</template>

<script>
import FilterDetailContainer from './FilterDetailContainer.vue'

export default {
  props: ['filter'],
  components: { FilterDetailContainer },
  data: () => ({
    count: null,
    condition: 'more',
    options: [
      { id: 'more', label: 'More than' },
      { id: 'less', label: 'Less than' },
      { id: 'equal', label: 'Equal to' }
    ],
  }),
  created() {
    const { more, less, equal } = this.filter
    if (more) {
      this.condition = 'more'
      this.count = more
    }
    if (less) {
      this.condition = 'less'
      this.count = less
    }
    if (equal) {
      this.condition = 'equal'
      this.count = equal
    }
  },
  methods: {
    save() {
      const filter = this.getFilterData()
      this.$emit('update:filter', filter)
      this.back()
    },
    getFilterData() {
      switch (this.condition) {
        case 'more':
          return { more: this.count }
        case 'less':
          return { less: this.count }
        case 'equal':
          return { equal: this.count }
        case 'between':
          return { between: this.count }
        default:
          return {}
      }
    },
    back() {
      this.$emit('onBack')
    }
  }
}
</script>